export default __webpack_public_path__ + "static/media/66t.d09c5fb1.jpg";